import actionTypes from "../actions/action-types";
import {combineReducers} from 'redux';
import parse_str from "locutus/php/strings/parse_str";
import {LOCATION_CHANGE} from "connected-react-router";
import {Animation, Position, Type} from "react-favico-js/dist/types";
import {get} from "../utils/dotutils";

const paceInitialState = {};
const paceReducer = (state = paceInitialState, action) => {
    let newState = {...state};
    switch (action.type) {
        case actionTypes.START_PACE:
            if(!newState[action.requestId]) {
                newState[action.requestId] = {percentDown: 0, percentUp: 0};
            }
        case actionTypes.END_PACE:
            delete newState[action.requestId];
            break;
        case actionTypes.SET_PACE_PERCENT:
            if (newState[action.requestId]) {
                newState[action.requestId].percentDown = action.percentDown !== null ? action.percentDown : newState[action.requestId].percentDown;
                newState[action.requestId].percentUp = action.percentUp !== null ? action.percentUp : newState[action.requestId].percentUp;
            }
            break;
    }
    return newState;
};

const modalInitialState = {state: 'off', title: '', text: '', type: 'default'};
const modalReducer = (state = modalInitialState, action) => {
    switch (action.type) {
        case actionTypes.SHOW_MODAL:
            return (action.properties || state);
        case actionTypes.CLOSE_MODAL:
            return modalInitialState;
        default:
            return state;
    }
};

const favicoInitialState = {
    animation: Animation.None,
    counter: 0,
    position: Position.Down,
    type: Type.Circle
};

const favicoReducer = (state = favicoInitialState, action) => {
    return {...state};
};

const templateInitialState = {
    sidebar: {sidebarCollapsed: false},
    menu: {
        active: '',
        keepOpened: false,
        items: []
    },
    content: {
        section: {heading: '', breadcrumbs: []},
        props: {},
        content: false
    }
};

const templateReducer = (state = templateInitialState, action) => {
    let newState = {...state};
    switch (true) {
        case action.type === actionTypes.TOGGLE_SIDEBAR:
            newState.sidebar = {sidebarCollapsed: !state.sidebar.sidebarCollapsed};
            break;
        case action.type === actionTypes.KEEP_OPENED_MENU:
            newState.menu.keepOpened = action.keepOpened;
            break;
        case action.type === LOCATION_CHANGE:
                const urlParams = {};
                parse_str(action.payload.location.search.substr(1), urlParams);
                if (urlParams.option) {
                    action.content = urlParams.option;
                    action.props = urlParams;
                } else {
                    action.content = null;
                    action.props = {};
                }
        case action.type === LOCATION_CHANGE || action.type === actionTypes.SET_CONTENT:
            newState = {
                ...newState,
                content: {
                    ...newState.content,
                    content: action.content,
                    props: action.props,
                    section: {}
                }
            };
        case action.type === LOCATION_CHANGE || action.type === actionTypes.SET_CONTENT || action.type === actionTypes.CREATE_MENU:
            newState.menu = {...newState.menu, items: action.items || newState.menu.items};
        case action.type === LOCATION_CHANGE || actionTypes.SET_CONTENT === action.type || action.type === actionTypes.CREATE_MENU || action.type === actionTypes.TOGGLE_MENU || action.type === actionTypes.ACTIVE_MENU:
            const activeToken = action.content !== undefined ? action.content : newState.menu.active;//state.menu.active == action.active ? '' : action.active;
            const activeTokenId = (action.props || {}).id !== undefined ? (action.props || {}).id : newState.menu.activeTokenId;
            newState = {...newState, menu: {...newState.menu, activeToken, activeTokenId}};
            const toggle = action.toggle;
            const toggleItem = action.toggleItem;
            const menuitems = newState.menu.items.map(a => ({...a}));
            let isSelected = false;
            let selectLevel = 0;
            const setItems = (items, level, prevlevel) => {
                items.map((item) => {
                    //delete item.opened;
                    delete item.active;
                    if (item.items) {
                        setItems(item.items, (level + 1), () => {
                            item.active = true;
                            prevlevel && prevlevel();
                        });
                    }
                    if (toggleItem !== undefined) {
                        item.opened = toggleItem === item.token || newState.menu.keepOpened ? (toggleItem === item.token ? toggle : item.opened) : false;
                    }
                    if (item.token === activeToken || item.token === activeToken + "." + activeTokenId) {
                        isSelected = true;
                        item.active = true;
                        //item.opened = newState.menu.keepOpened ? item.opened : (toggleItem == item.token ? toggle : item.opened);
                        selectLevel = level;
                        if (!(item.items && item.items.length)) {
                            newState.content = {
                                ...newState.content,
                                //content: item.token,
                                //props: {...newState.content.props},
                                section: {...newState.content.section, heading: item.label}
                            }
                        }
                    }
                    if (isSelected && selectLevel > level) {
                        if (!level) {
                            item.active = true;
                            isSelected = false;
                        }
                        prevlevel && prevlevel();
                    }
                });
            };
            setItems(menuitems, 0, () => {});
            newState.menu.items = menuitems;
    }
    return newState;
};

const userInitialState = {id: null};

const userReducer = (state = userInitialState, action) => {
    let returnState = state;
    switch (action.type) {
        case actionTypes.SET_USER:
            let newState = {};
            newState = {...action.data};
            returnState = newState;
            break;
        default:
            returnState = state;
            break;
    }
    returnState.hasPermission = function(permission) {
        return !!(this.privileges || []).find((privilege) => privilege.name === permission);
    }.bind(returnState);
    return returnState;
};

const tillInitialState = {id: null};

const tillReducer = (state = tillInitialState, action) => {
    let returnState = state;
    switch (action.type) {
        case actionTypes.SET_TILL:
            let newState = {};
            newState = {...action.data};
            returnState = newState;
            break;
        case actionTypes.REDUX_STORE_CHANGED:
            const newTill = get(action.payload, "app.till")
            if (newTill.id) {
                returnState = {...get(action.payload, "app.till")};
            }
            break;
    }
    return returnState;
};

const appReducer = combineReducers({
    favico: favicoReducer,
    pace: paceReducer,
    modal: modalReducer,
    template: templateReducer,
    user: userReducer,
    till: tillReducer
});

export default appReducer;